import type { StoreSpecial } from '@jane/bloom/types/schemas/marketplace/storeSpecials';

export const sortSpecials = (specials: StoreSpecial[]) =>
  specials.sort((a, b) => {
    if (!a.start_date) return 1;
    if (!b.start_date) return -1;
    if (!a.start_date && !b.start_date) return 0;
    const dateA = new Date(a.start_date);
    const dateB = new Date(b.start_date);

    return dateB.getTime() - dateA.getTime();
  });
